<span>
	<span *ngIf="!hideInput">
        <span id="ManipIntegerClickerValue"
              class="ManipIntegerClickerValue cursor"
              (click)="showControlModal()">{{inputValue}}</span>
    </span>

	<span *ngIf="!(hideStudentManipControlBar | async)" id="ManipIntegerClickerBar" class="ManipIntegerClickerBar StudentManipControlBar">
			<div class="kh-bottom-bar-container w-100 d-flex justify-content-center align-content-center kh-horizontal-scroll-bar ">
            <div class="kh-bottom-bar-content-container w-100 d-flex justify-content-between align-items-center  flex-shrink-0">
                <div class="w-100 d-flex align-items-center   flex-shrink-0 flex-grow-1">
                    <div class=" d-flex align-items-center kh-justify-content-align-controls  flex-shrink-0 flex-grow-1">
					<button #add *ngIf="!reverseButtonOrder" type="button"
						class="btn-md kh-blue-button white kh-lg-title-text text-uppercase kh-no-wrap kh-secondory-controls " (click)="addValue(1)"
						[disabled]="questionClosed">
						<fa-icon [icon]="['fas', 'angle-up']" *ngIf="!upLabel"></fa-icon>
						<fa-icon [icon]="['fas','plus']" *ngIf="upIsPlus"></fa-icon>
						<span *ngIf="upIsNotPlus" [innerHTML]="upLabel | unsafeHtml"></span>
					</button>
					<button #substract type="button" class="btn-md kh-blue-button white kh-lg-title-text text-uppercase kh-no-wrap kh-secondory-controls"
						(click)="addValue(-1)" [disabled]="questionClosed">
						<fa-icon [icon]="['fas','angle-down']" *ngIf="!downLabel"></fa-icon>
						<fa-icon [icon]="['fas','minus']" *ngIf="downIsMinus"></fa-icon>
						<span *ngIf="downIsNotMinus" [innerHtml]="downLabel | unsafeHtml"></span>
					</button>
					<button #reverse *ngIf="reverseButtonOrder" type="button"
						class="btn-md kh-blue-button white kh-lg-title-text text-uppercase kh-no-wrap kh-secondory-controls" (click)="addValue(1)"
						[disabled]="questionClosed">
						<fa-icon [icon]="['fas', 'angle-up']" *ngIf="!upLabel"></fa-icon>
						<fa-icon [icon]="['fas','plus']" *ngIf="upIsPlus"></fa-icon>
						<span *ngIf="upIsNotPlus" [innerHtml]="upLabel | unsafeHtml"></span>
					</button>
					
				</div>
				<div class="justify-content-end kh-submit-width  flex-shrink-0 ">
					<button 
						class="btn-md kh-green-button kh-green-accessible white kh-lg-title-text text-uppercase kh-no-wrap  manipulative-submit-button"
						type="button" *ngIf="isManipChanged && !questionClosed" (click)="submit(inputValue)"
						[class.animated]="isManipChanged"><img
							src="https://staticcontent.knowledgehook.com/content/icons/question/submitarrow-onprimary.svg">
					</button> 
				</div>
				</div>
				
				
			</div>
		</div>
	</span>
</span>